import { Chip } from '@mui/material';
import { useEffect, useState } from 'react';

interface NoShowCountdownProps {
  lockedAt: string;
}

const NoShowCountdown = ({ lockedAt }: NoShowCountdownProps) => {
  const [remaining, setRemaining] = useState('');
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    const update = () => {
      const diff = new Date(lockedAt).getTime() - Date.now();
      if (diff <= 0) {
        setExpired(true);
        setRemaining('Verrouillé');
        return;
      }
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      setRemaining(`${hours}h ${minutes}min restantes`);
    };

    update();
    const interval = setInterval(update, 60000);
    return () => clearInterval(interval);
  }, [lockedAt]);

  return <Chip label={remaining} color={expired ? 'default' : 'warning'} size="small" variant="outlined" />;
};

export default NoShowCountdown;
